import { render, staticRenderFns } from "./ModalCurrencyMismatch.vue?vue&type=template&id=132ed973"
import script from "./ModalCurrencyMismatch.vue?vue&type=script&lang=js"
export * from "./ModalCurrencyMismatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports